import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TestAccession } from '../../models/TestAccession';
import { Source } from '../../models/Source';
import 'rxjs/add/operator/toPromise';
import { CumulativeQuery } from '../../models/CumulativeQuery';
import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'result-details',
  templateUrl: './result-details.component.html',
  styleUrls: ['./result-details.component.css']
})


export class ResultDetailsComponent implements OnInit {

  testAccession: TestAccession;
  UserSource: Source;
  @Output() onHide = new EventEmitter<any>();
  @Input() set _testAccession(_testAccession: TestAccession) {
    //console.log("testAccession setter", _testAccession)
    this.testAccession = _testAccession;
    this.cumShouldBeEmpty = true;
    this.cumClicked = false;
  }

  //@Input() set resultDetails(results: TestAccession[]) {}


  Id: string;
  cumClicked = false;
  cumulativeQuery: CumulativeQuery
  cumShouldBeEmpty = false;

  constructor(private authService: AuthService) { }

  cumViewClicked(testCode: string) {
    this.cumClicked = true;
    this.cumShouldBeEmpty = false;
    console.log("loading ", this.testAccession, testCode );
    this.cumulativeQuery = { surname: this.testAccession.Surname, forename: this.testAccession.ForeName, dob: this.testAccession.Dob.toString(), testCode: testCode };
  }

  hideCum(event: any) {
    this.cumClicked = false;
  }

  raiseHide(event : any) {
    this.onHide.emit(event);
  }

  print(ebent: any) {
    window.print();
  }

  downloadXML(testAccession: TestAccession) {
    var dataStr = this.getXMLContent(testAccession);
    //var dataStr = "";
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.xml`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  downloadCSV(testAccession: TestAccession) {
    var dataStr = "data:text/csv;charset=utf-8," + (testAccession.Title + " " + testAccession.ForeName + " " + testAccession.Surname + "," + testAccession.Dob + "," + testAccession.RequestDate + "," + testAccession.LabNumber + "," + testAccession.Sex + "," + testAccession.AttendingDr + "," + testAccession.SampleDate + "," + testAccession.ReportedDate + "\r\n").trim();
    dataStr += testAccession.Tests.map(t => t.TestName + "\r\n" + t.ResultLines.map(r => r.TestName + "," + r.Result.replace(/(?:\r\n|\r|\n)/g, ' ')).join("\r\n")).join("\r\n"); 
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.csv`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  downloadJSON(testAccession: TestAccession) {
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(testAccession));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  getXMLContent(testAccession: TestAccession) {
    var dataStr = "data:text/xml;charset=utf-8,<TestAccession>";
    dataStr += "<Name>" + (testAccession.Title + " " + testAccession.ForeName + " " + testAccession.Surname).trim() + "</Name>";
    dataStr += "<DOB>" + testAccession.Dob + "</DOB>";
    dataStr += "<RequestDate>" + testAccession.RequestDate + "</RequestDate>";
    dataStr += "<LabNo>" + testAccession.LabNumber + "</LabNo>";
    dataStr += "<Sex>" + testAccession.Sex + "</Sex>";
    dataStr += "<AttendingDr>" + testAccession.AttendingDr + "</AttendingDr>";
    dataStr += "<SampleDate>" + testAccession.SampleDate + "</SampleDate>";
    dataStr += "<ReportDate>" + testAccession.ReportedDate + "</ReportDate>";
    dataStr += "<Tests>";
    testAccession.Tests.forEach(function (test) {
      dataStr += "<TestResult><TestCode>" + test.TestCode + "</TestCode><TestName>" + test.TestName + "</TestName>";
      test.ResultLines.forEach(function (resultline) {
        dataStr += "<Result>";
        dataStr += "<TestCode>" + resultline.TestCode + "</TestCode>";
        dataStr += "<TestName>" + resultline.TestName + "</TestName>";
        dataStr += "<Resultline>" + resultline.Result.replace(/(?:\r\n|\r|\n)/g, ' ') + "</Resultline>";
        dataStr += "</Result>";
      })
      dataStr += "</TestResult>";
    });
    dataStr += "</Tests>";
    console.log(dataStr)
    return dataStr;
  }

  ngOnInit() {
    //console.log('details init');
    this.UserSource = this.authService.getLoginSource();
    this.cumClicked = false;
    this.cumShouldBeEmpty = true;
  }
}
